import { render, staticRenderFns } from "./tabs-primary.vue?vue&type=template&id=1eeb211e&scoped=true&"
import script from "./tabs-primary.vue?vue&type=script&lang=js&"
export * from "./tabs-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb211e",
  null
  
)

export default component.exports